import { Typography } from "antd"
import React from "react"

export function HeaderBlock() {
  return (
    <Typography.Text type="secondary" italic className="block text-center py-2">
      Header block — no configuration needed
    </Typography.Text>
  )
}
